<template>
  <div>
    <div class="box material-detail container">
      <h3>素材详情</h3>
      <div class="content">
        <div class="img-box">
          <div class="img">
            <span
              class="bg"
              :style="{ backgroundImage: 'url(' + adData.imageurl + ')' }"
            ></span>
            <el-image :src="adData.imageurl" fit="contain"></el-image>
          </div>
          <p
            class="desc"
            title="这是广告标题Lorem ipsum dolor sit amet consectetur
            adipisicing elit. Doloribus corporis porro minima natus error, quasi
            nemo enim ab numquam doloremque tempore alias? Ullam corrupti
            explicabo iure, rerum blanditiis pariatur consequatur!"
          >
            {{ adData.text }}
          </p>
        </div>
        <div class="ad-info">
          <div class="ad-info-inner">
            <div class="ad-data">
              <div class="data1 ad-data-item">
                <span class="bold">{{
                  adData.showDayNum ? adData.showDayNum : 0
                }}</span>
                <p>投放天数</p>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="data2 ad-data-item">
                <span class="bold">{{
                  adData.showNum ? adData.showNum : 0
                }}</span>
                <p>展现次数</p>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="data3 ad-data-item">
                <span class="bold"
                  >{{
                    ((adData.clickRate ? adData.clickRate : 0) * 100).toFixed(
                      2
                    )
                  }}%</span
                >
                <p>点击率</p>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="data4 ad-data-item">
                <el-popover placement="top" trigger="hover">
                  <div class="device-num">
                    <div class="device-display">
                      <span class="bold">{{ adData.deviceNum }}</span>
                      <p>展示设备数</p>
                    </div>
                    <div class="device-click">
                      <span class="bold">{{ adData.clickDeviceNum }}</span>
                      <p>点击设备数</p>
                    </div>
                  </div>
                  <div slot="reference">
                    <span class="bold">{{ adData.deviceNum }}</span>
                    <p>设备数</p>
                  </div>
                </el-popover>
              </div>
              <el-divider direction="vertical"></el-divider>
              <div class="data5 ad-data-item">
                <span class="bold">{{
                  (adData.ecpm ? adData.ecpm : 0).toFixed(2)
                }}</span>
                <p>eCPM</p>
              </div>
            </div>
            <div class="other-data">
              <div>
                <label>行业分类：</label>
                <span>
                  <!-- <span v-for="(sub_item, index) in adData.classl1" :key="index">
                  {{ sub_item }}
                  <span v-if="!!adData.classl2 && adData.classl2[index]"
                    >| {{ adData.classl2 ? adData.classl2[index] : "" }}</span
                  >
                </span> -->
                  <span
                    v-for="(sub_item, index) in adData.classl2"
                    :key="index"
                  >
                    <span> {{ sub_item }} </span
                    ><span v-if="index < adData.classl2.length - 1"> | </span>
                  </span>
                </span>
              </div>
              <!-- <div>
                <label>广告位：</label>
                <span>{{ adData.platform }}</span>
              </div>
              <div>
                <label>素材类型：</label>
                <span>{{ adData.platform }}</span>
              </div> -->
              <div>
                <label>投放渠道：</label>
                <span v-if="!!adData.platform">
                  <div
                    class="platform"
                    v-for="item in adData.platform.split(',')"
                    :key="item"
                  >
                    <img
                      class="icon"
                      v-if="item == '广点通'"
                      src="../assets/img/优量汇.png"
                      alt="优量汇"
                    /><img
                      class="icon"
                      v-else-if="item == '头条'"
                      src="../assets/img/头条.png"
                      alt="头条"
                    />
                  </div>
                </span>
              </div>
              <div>
                <label>设备类型：</label>
                <span
                  ><span
                    ><img
                      v-if="adData.platform == 'Android'"
                      src="../assets/img/安卓.png"
                      class="icon"
                      alt="" />
                    <img
                      v-else
                      src="../assets/img/苹果.png"
                      class="icon"
                      alt="" /></span
                ></span>
              </div>
              <div>
                <label>投放周期：</label>
                <span>{{ adData.starttime }}~{{ adData.endtime }}</span>
              </div>
              <!-- <div>
              <label>投放天数：</label>
              <span>{{ adData.showDayNum }}天</span>
            </div> -->
              <!-- <div>
              <label>素材类型：</label>
              <span>图片</span>
            </div> -->
            </div>
          </div>
          <div class="btns">
            <el-button
              class="download"
              size="mini"
              type="primary"
              plain
              @click="download()"
              >下载素材<i class="el-icon-download el-icon--right"></i
            ></el-button>
            <el-button
              class="share"
              size="mini"
              type="primary"
              plain
              id="copy"
              @click="copy"
              :data-clipboard-text="copyData"
              >分享素材<i class="el-icon-share el-icon--right"></i
            ></el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="box show-time container" v-if="showTimeShow">
      <h3>时间投放趋势</h3>
      <div class="content">
        <div class="chart">
          <div id="chartShowTime" class="chart"></div>
        </div>
      </div>
    </div>
    <div class="box city-level container" v-if="cityLevelShow">
      <h3>城市等级分布</h3>
      <div class="content">
        <div class="chart">
          <div id="chartCityLevel" class="chart"></div>
        </div>
      </div>
    </div>
    <div class="box zone container" v-if="zoneShow">
      <h3>投放地域分布</h3>
      <div class="content">
        <div class="chart">
          <div id="chartZone" class="chart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import _ from "underscore";
export default {
  name: "AdMaterialDetail",
  mounted() {
    let id = this.$route.query["id"];
    this.id = id;
    this.queryMaterialDetail(id);

    // this.queryShowTimeData(id);
    this.queryCityLevelData(id);
    this.queryZoneData(id);
    this.chartShowTime = this.$echarts.init(
      document.getElementById("chartShowTime")
    );
    this.chartCityLevel = this.$echarts.init(
      document.getElementById("chartCityLevel")
    );
    this.chartZone = this.$echarts.init(document.getElementById("chartZone"));
    window.addEventListener("resize", this.resize);
  },
  data() {
    return {
      id: "",
      chartShowTime: {},
      chartCityLevel: {},
      chartZone: {},
      adData: {},
      showTimeData: [],
      cityLevelData: [],
      zoneData: [],
      copyData:
        "这个素材很不错，分享给你！【火眼-ADmobile旗下广告监测分析平台】",
      showTimeShow: true,
      cityLevelShow: true,
      zoneShow: true,
    };
  },
  methods: {
    resize() {
      this.chartShowTime.resize();
      this.chartCityLevel.resize();
      this.chartZone.resize();
    },
    download() {
      this.$http
        .get("/fireeye/material/originalimageurl?id=" + this.id)
        .then((res) => {
          let data = res.data;
          if (data.code == 1) {
            this.$http
              .get(data.data, {
                responseType: "arraybuffer", //指定返回数据的格式为blob
              })
              .then((res) => {
                console.log(res);
                let data = res.data;
                var src =
                  "data:image/jpg;base64," +
                  btoa(
                    new Uint8Array(data).reduce(
                      (data, byte) => data + String.fromCharCode(byte),
                      ""
                    )
                  );
                this.srcImg = src; //图片回显
                var link = document.createElement("a");
                link.href = src;
                link.download = this.id + ".jpg";
                link.click();
              });
          } else {
            this.$message.error("下载图片失败");
          }
        });
    },
    copy() {
      this.copyData += location.href;
      const clipboard = new Clipboard("#copy");
      clipboard.on("success", (e) => {
        this.$message.success("已复制到剪贴板！");
        clipboard.destroy();
      });
    },
    queryMaterialDetail(id) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      this.$http
        .get("/fireeye/material/details?id=" + id)
        .then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code == 1) {
            data = data.data;
            this.adData = data;
            this.queryShowTimeData(id);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    queryShowTimeData(id) {
      this.$http
        .get(
          "/fireeye/material/trend?id=" +
            id +
            "&st=" +
            this.adData.starttime.replaceAll(".", "-") +
            "&ed=" +
            this.adData.endtime.replaceAll(".", "-")
        )
        .then((res) => {
          let data = res.data;
          if (data.code == 1 && !!data.data && data.data.length > 0) {
            data = data.data;
            this.showTimeData = data;
            this.drawShowtimeChart();
          } else {
            this.showTimeShow = false;
          }
        });
    },
    drawShowtimeChart() {
      let xAxis = [];
      let display = [];
      let click = [];
      for (let item of this.showTimeData) {
        xAxis.push(item.day);
        display.push(item.show);
        click.push(item.click);
      }
      let series = [
        {
          name: "展示",
          type: "line",
          data: display,
        },
        {
          name: "点击",
          type: "line",
          data: click,
        },
      ];

      console.log(xAxis, display, click);
      // 指定图表的配置项和数据
      var option = {
        tooltip: { show: true, trigger: "axis" },
        legend: {
          data: ["展示", "点击"],
        },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: series,
      };

      this.chartShowTime.setOption(option);
    },
    queryCityLevelData(id) {
      this.$http
        .get("/fireeye/material/distribution/city?id=" + id)
        .then((res) => {
          let data = res.data;
          if (data.code === 1 && !!data.data && !_.isEmpty(data.data)) {
            this.cityLevelData = data.data;
            this.drawCityLevelChart();
          } else {
            this.cityLevelShow = false;
          }
        });
    },
    drawCityLevelChart() {
      let xAxis = [];
      let yAxis = [];
      let all = 0;
      for (let key in this.cityLevelData) {
        all += this.cityLevelData[key];
      }
      for (let key in this.cityLevelData) {
        let value = ((this.cityLevelData[key] / all) * 100).toFixed(2);
        xAxis.push(key);
        yAxis.push(value);
      }
      // 指定图表的配置项和数据
      var option = {
        tooltip: { show: true, trigger: "axis", formatter: "{b}<br/>{c}%" },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: yAxis,
            type: "bar",
            barWidth: "40",
            itemStyle: {
              color: "#02A7F0",
            },
          },
        ],
      };

      this.chartCityLevel.setOption(option);
    },
    queryZoneData(id) {
      this.$http
        .get("/fireeye/material/distribution/province?id=" + id)
        .then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code === 1 && !!data.data && !_.isEmpty(data.data)) {
            this.zoneData = data.data;
            this.drawZoneChart();
          } else {
            this.zoneShow = false;
          }
        });
    },
    drawZoneChart() {
      let all = 0;
      let max = 0;
      let source = [];
      for (let key in this.zoneData) {
        if (this.zoneData[key] > max) {
          max = this.zoneData[key];
        }
        all += this.zoneData[key];
      }
      for (let key in this.zoneData) {
        let value = ((this.zoneData[key] / all) * 100).toFixed(2);
        source.push([key, value]);
      }

      let option = {
        tooltip: { show: true, trigger: "axis", formatter: "{c}%" },
        xAxis: {
          type: "value",
          min: 0,
          max: 100,
          position: "top",
          interval: 10,
        },
        yAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
        },
        dataset: [
          { dimensions: ["name", "value"], source: source },
          {
            transform: {
              type: "sort",
              config: { dimension: "value", order: "asc" },
              print: true,
            },
          },
        ],
        series: [
          {
            type: "bar",
            datasetIndex: 1,
            encode: { x: "value", y: "name" },
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            itemStyle: {
              color: "#02A7F0",
            },
          },
        ],
      };
      this.chartZone.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 3px;
  box-shadow: 3px 3px 5px #ddd;
  margin-bottom: 30px;
  padding: 20px;
  background-color: #fff;

  h3 {
    text-align: left;
    padding-left: 10px;
    border-left: 3px solid #00a2ff;
    font-weight: 500;
    font-size: 18px;
  }
}
.device-num {
  display: flex;
  text-align: center;
  gap: 10px;
}
.material-detail {
  .content {
    display: flex;
    font-size: 14px;

    .img-box {
      .img {
        width: 462px;
        height: 347px;
        border-radius: 5px;
        position: relative;
        overflow: hidden;
        .bg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 140%;
          height: 140%;
        }
        .bg:after,
        .bg:before {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-color: #ebeef5;
          background-image: inherit;
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: cover;
          content: "";
          filter: blur(10px);
        }
        .el-image {
          width: 100%;
          height: 100%;
          display: block;
          img {
            object-fit: contain;
          }
        }
      }
      .desc {
        width: 462px;
        text-align: left;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #212121;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
    }
    .ad-info {
      flex: 1;
      padding: 0 24px;
      display: flex;
      flex-direction: column;

      .platform {
        display: inline-block;
        padding-bottom: 0 !important;
        .icon {
          width: 20px;
          height: 20px;
        }
      }

      .ad-info-inner {
        .ad-data {
          display: flex;
          justify-content: space-between;
          text-align: center;
          .el-divider {
            height: 24px;
            margin-top: 11px;
          }
          .ad-data-item {
            flex: 1;
            .bold {
              font-size: 24px;
              font-family: DINCond-Bold, DINCond;
              font-weight: bold;
              color: #222222;
              line-height: 28px;
            }
            p {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #757575;
              line-height: 20px;
            }
          }
        }
        .other-data {
          text-align: left;
          margin-top: 16px;
          div {
            padding-bottom: 16px;
            label {
              display: inline-block;
              margin-right: 10px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #757575;
              line-height: 22px;
              width: 80px;
            }
            span {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #212121;
              line-height: 22px;

              .icon {
                width: 20px;
                height: 20px;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .btns {
        display: flex;
        justify-content: space-between;
        padding: 40px 0 12px;
        .el-button {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 25px;
        }
        .download {
          background-color: #2196f3;
          color: #fff;
          width: 434px;
          height: 58px;
        }
        .share {
          background-color: #fff;
          color: #2196f3;
          width: 216px;
          height: 58px;
        }
      }
    }
  }
}
.chart {
  width: 100%;
  height: 500px;
}
.show-time {
  #chartShowTime {
  }
}
</style>